import template from './uploadHistory.html';
import controller from './uploadHistory.controller';

let uploadHistoryComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default uploadHistoryComponent;



// WEBPACK FOOTER //
// ./app/components/uploadHistory/uploadHistory.component.js